import React from 'react';
import { favoriteSessionsArray } from '../../utils/data/SessionsData';

function SessionsComponent() {
  return (
    <section className='grid w-full py-16'>
      {/* Header */}
      <div className='grid text-center pb-10'>
        <h2 className='text-4xl lg:text-5xl font-titleFont text-neonGreen tracking-wide'>
          Train in the Shadows
        </h2>
      </div>

      {/* Grid */}
      <div className='grid gap-6 px-8 sm:px-10 md:px-20 lg:px-32 lg:grid-cols-2'>
        {favoriteSessionsArray.map((session, index) => (
          <SessionCard key={session.title} session={session} index={index} />
        ))}
      </div>
    </section>
  );
}

const SessionCard = ({ session, index }) => {
  return (
    <article
      className={`grid h-52 sm:h-64 lg:h-72 place-items-center overflow-hidden group relative
                  bg-center bg-cover transition-all duration-300 border-solid border-2`}
      style={{ backgroundImage: `url(${session.image})` }}
    >
      {/* Dark overlay */}
      <div className='absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-all duration-300'></div>

      {/* Title */}
      <div className='relative grid h-fit gap-y-4 z-10 text-white text-center px-4'>
        <h3 className='text-white font-titleFont text-2xl sm:text-3xl tracking-widest'>
          {session.title}
        </h3>
        <p className='text-white font-titleFont text-base tracking-widest md:max-w-[50%] md:mx-auto'>
          {session.description}
        </p>
      </div>
    </article>
  );
};

export default SessionsComponent;
